import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'upload-dialog',
  templateUrl: 'upload-dialog.html',
})
export class UploadDialog {
  constructor(private dialogRef: MatDialogRef<UploadDialog>) {}

  yes(): void {
    this.dialogRef.close(true);
  }
}
